import React from "react";
import { RagIndicator } from "../cr/RagIndicator";
import { RagColours } from "../../refData/RagColours";

interface UpdateRagDisplayProps {
    rag: RagColours | null;
}

const UpdateRagDisplay: React.FC<UpdateRagDisplayProps> = ({ rag }) => {
    let text = "";

    switch (rag) {
        case RagColours.DarkGreen:
            text = "On track, no major issues";
            break;
        case RagColours.Green:
            text = "Generally on track, minor issues only";
            break;
        case RagColours.Amber:
            text = "Some concerns, requires attention";
            break;
        case RagColours.Red:
            text = "Severe concerns, major risks present";
            break;
        case RagColours.DarkRed:
            text = "Critical issues, outcome not achievable";
            break;
        default:
            text = "No rating available";
            break;
    }

    return (
        <div className="update-rag-container">
            <div className="rag-indicator">
                <RagIndicator rag={rag} />
            </div>
            <span className="rag-text">{text}</span>
        </div>
    );
};

export default UpdateRagDisplay;
